import { CommonModule } from '@angular/common';
import { Component, inject, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { MultiSelectModule } from 'primeng/multiselect';
import { SelectModule } from 'primeng/select';
import { DividerModule } from 'primeng/divider';
import { DrawerModule } from 'primeng/drawer';
import { UserService } from '@services/user.service';
import { SessionService } from '@utils/session.service';
import { UtilsService } from '@utils/utils.service';
import { ToastService } from '@utils/toast.service';

@Component({
  selector: 'app-create-bank-group',
  imports: [CommonModule, FormsModule, ReactiveFormsModule, InputTextModule, ButtonModule, MultiSelectModule, SelectModule, DividerModule, DrawerModule],
  templateUrl: './create-bank-group.component.html',
  styleUrl: './create-bank-group.component.scss',
})
export class CreateBankGroupComponent implements OnInit {
  @Output() saved = new EventEmitter<void>();
  private formBuilder = inject(FormBuilder);
  private userService = inject(UserService);
  private utils = inject(UtilsService);
  private sessionService = inject(SessionService);
  private toastService = inject(ToastService);

  @Input() visible: boolean = false;
  @Output() visibleChange = new EventEmitter<boolean>();

  public isSaving = false;
  public listUsers: any[] = [];

  public form = this.formBuilder.group({
    NAME: [null, Validators.required],
    USERS: [null, Validators.required],
    BANK: this.formBuilder.group({
      BANCO: [null, Validators.required],
      TITULAR: [null, Validators.required],
      NUMERO_CUENTA: [null, Validators.required],
      CLABE: [null, [Validators.required, Validators.minLength(18), Validators.maxLength(18)]],
    }),
  });

  private initialFormValues: any;

  ngOnInit(): void {
    this.initialFormValues = this.form.getRawValue();

    const userId = this.sessionService.getUser()?.userId;

    this.userService.getUsersOfUser(Number(userId)).then((response: any) => {
      this.listUsers = response.childrens.map((user: any) => ({ label: user.nickname, value: user.userId }));
      this.listUsers = this.utils.orderArrayBy(this.listUsers, 'label');
    });
  }

  createBankGroup(): void {
    this.isSaving = true;

    this.userService
      .createBankGroup(this.form.value)
      .then(() => {
        this.toastService.success('Se creó el grupo de bancos.');
        this.saved.emit();
        this.closeDrawer();
      })
      .catch((error: any) => {
        this.toastService.error(error.error?.data?.message || 'Ocurrió un error al crear el grupo de bancos.');
      })
      .finally(() => {
        this.isSaving = false;
      });
  }

  public closeDrawer(): void {
    this.form.reset(this.initialFormValues);
    this.visible = false;
    this.visibleChange.emit(false);
  }
}
